/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2021 Open Assessment Technologies SA;
 */

import { getTestSessionUserDataService } from '../../../session/testSessionUserDataService';

/**
 * Allow works with store for exact tool, by wrapping logic into simple methods
 * @param {String} serviceCallId
 * @param {String} toolName
 * @returns {{set(String, Boolean): void, get(String): Boolean}|*}
 */
export default function toolsStoreHandler(serviceCallId, toolName) {
    const toolsStore = getTestSessionUserDataService(serviceCallId).getToolsStore();

    return {
        /**
         * Get any property in testToolsStore
         * @param {String} key - visible, enabled, open...
         * @returns {Boolean}
         */
        get(key) {
            const state = toolsStore.getTestToolState(toolName);
            return state && state[key];
        },

        /**
         * Set any property in testToolsStore
         * @param {String} key - visible, enabled, open...
         * @param {Boolean} value
         */
        set(key, value) {
            const state = toolsStore.getTestToolState(toolName) || {};
            state[key] = value;
            toolsStore.setTestToolState(toolName, state);
        }
    };
}
